<div class="modal-header">
  <h4 class="modal-title text-center" *ngIf="status !== SwapStatus.complete && (isStake || isWithdraw)">
    {{ (isStake ? 'staking.claim_stake_title' : 'staking.withdraw_title') | translate }}
  </h4>
  <h4 class="modal-title text-center" *ngIf="status == SwapStatus.not_started && !isStake && !isWithdraw">{{ 'widget.claim_title' | translate }}</h4>
  <h4 class="modal-title text-center" *ngIf="status == SwapStatus.in_progess && !isStake && !isWithdraw">{{ 'staking.claim_inprogress_title' | translate }}</h4>
  <h4 class="modal-title text-center" *ngIf="status == SwapStatus.complete && !isStake && !isWithdraw">{{ 'staking.claim_success_title' | translate }}</h4>
  <h4 class="modal-title text-center" *ngIf="status == SwapStatus.complete && isStake && !isWithdraw">{{ 'staking.stake_transaction_success' | translate }}</h4>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.in_progess && isWithdraw">
  <img src="/assets/images/popup-icons/progress.svg" alt="failed" class="statusIcon" />
  <p class="text-center mb-3 font-sm-15">{{ 'staking.withdraw_inprogress' | translate }}</p>
</div>

<!-- ========== claim and stake section =============== -->

<div class="modal-body text-center" *ngIf="status == SwapStatus.in_progess && isStake && !isWithdraw">
  <img src="/assets/images/popup-icons/progress.svg" alt="failed" class="statusIcon" />
  <p class="text-center mb-3 font-sm-15">{{ 'staking.claim_stake_desc' | translate }}</p>
</div>

<!-- ========== normal claim section =============== -->

<div class="modal-body text-center" *ngIf="status == SwapStatus.not_started && !isStake && !isWithdraw">
  <img src="/assets/images/popup-icons/progress.svg" alt="failed" class="statusIcon" />
  <p class="text-center mb-3 font-sm-15">{{ 'widget.claim_help' | translate }}</p>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.in_progess && !isStake && !isWithdraw">
  <img src="/assets/images/popup-icons/progress.svg" alt="failed" class="statusIcon" />
  <p class="text-center mb-3 font-sm-15">{{ 'staking.claim_inprogress' | translate }}</p>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.complete">
  <img src="/assets/images/popup-icons/success.svg" alt="complete" class="statusIcon" />
  <div class="text-center mb-3 font-sm-15">{{ (isStake ? 'staking.stake_claim_success' : isWithdraw ? 'staking.withdraw_success' : 'staking.claim_success') | translate }}</div>
  <a type="button" href="{{ lang }}/staking" class="btn btn-primary fs-7 w-auto" (click)="modalRef.hide()">{{ 'misc.close' | translate }}</a>
</div>

<div class="modal-body text-center" *ngIf="status == SwapStatus.failed">
  <img src="/assets/images/popup-icons/error.svg" alt="failed" class="statusIcon" />
  <div class="text-center mb-3 font-sm-15">{{ 'staking.transaction_rejected' | translate }}</div>
  <div class="footer">
    <button type="button" class="btn btn-primary fs-7 w-50" (click)="modalRef.hide()">{{ 'misc.close' | translate }}</button>
  </div>
</div>
